var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAmpliaciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.01 102.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #ff6868;\n        stroke-linejoin: round;\n        stroke-width: 9px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #ff6868;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Form_3",
    "data-name": "Form 3",
    className: "cls-3",
    d: "M32.88,99.75c-16.01,0-27.1-11.11-27.6-27.62l-.02-1.14v-37.6C5.26,16.69,15.9,5.11,31.74,4.57l1.11-.02h43.99c2.72.01,4.92,2.23,4.91,4.95-.01,2.45-1.82,4.52-4.24,4.86l-.57.04h-44.06c-10.55,0-17.35,6.88-17.74,17.95l-.02,1.05v37.55c0,11.43,6.27,18.5,16.78,18.92l1,.02h40c10.55,0,17.35-6.86,17.75-17.91l.02-1.05V29.92c-.02-2.72,2.17-4.94,4.89-4.95,2.48-.02,4.59,1.82,4.91,4.29l.04.57v41.13c0,16.69-10.64,28.25-26.48,28.78l-1.11.02h-40.04ZM28.57,68l-.53-.35c-1.97-1.48-2.56-4.18-1.38-6.35l.34-.52,13.97-18.17c1.51-1.94,4.21-2.48,6.35-1.27l.52.35,12.06,9.47,10.59-13.65c1.68-2.14,4.78-2.52,6.92-.84,1.91,1.49,2.44,4.15,1.27,6.27l-.34.52-13.68,17.66c-1.51,1.94-4.21,2.48-6.35,1.27l-.52-.34-12.06-9.46-10.88,14.15c-.95,1.21-2.39,1.91-3.93,1.91-.82-.02-1.63-.24-2.34-.65h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2_Kopie_2",
    "data-name": "Ellipse 2 Kopie 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 87.8,
    cy: 17.21,
    r: 9.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 87.8,
    cy: 17.21,
    r: 12.71
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAmpliaciones);
export default __webpack_public_path__ + "static/media/logo_ampliaciones.66e0d4bf27899e0e6ec6f315feb77865.svg";
export { ForwardRef as ReactComponent };